module.exports = __webpack_public_path__ + "assets/img/title-30b74c16.png";